import { Organisation } from 'src/app/service/organisation/organisation';
import { MatTableDataSource } from '@angular/material/table';

export class NetzbetreiberDataSource extends MatTableDataSource<Organisation> {
}
